import { Button, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function CreateRecordButton({ route }) {
  const history = useHistory();

  return (
    <Col>
      <div style={{ textAlign: "end" }}>
        <Button
          className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          type="button"
          onClick={() => {
            history.push(route);
          }}
        >
          <i className="fa fa-plus" />{" "}
          Create
        </Button>
      </div>
    </Col>
  );
}

export default CreateRecordButton;